// extracted by mini-css-extract-plugin
module.exports = {"link":"XlppQ","docBlock":"Q8T7k","second":"hR-hO"};